import { escapeRegExp } from './index'

/** Separador visual de miles en inputs de monto. */
export const AMOUNT_THOUSAND_SEPARATOR = ','

const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`)

/** Valida el valor crudo almacenado (solo dígitos y un punto decimal). */
export function isValidAmountInputRaw(raw: string): boolean {
  if (raw === '') return true
  return inputRegex.test(escapeRegExp(raw))
}

function stripThousandSeparators(value: string): string {
  return value.replace(/,/g, '')
}

function parseDecimalComma(value: string, commaIndex: number): string {
  return (
    value.slice(0, commaIndex).replace(/[.,]/g, '') +
    '.' +
    value.slice(commaIndex + 1).replace(/[.,]/g, '')
  )
}

/** Normaliza lo que escribe el usuario a la forma cruda usada por el estado del swap. */
export function parseAmountInput(input: string): string {
  if (input === '') return ''

  let normalized = input.replace(/[\s\u00A0\u202F\u2009]/g, '')

  const lastComma = normalized.lastIndexOf(',')
  const lastPeriod = normalized.lastIndexOf('.')

  if (lastPeriod >= 0 && lastPeriod > lastComma) {
    normalized = stripThousandSeparators(normalized)
  } else if (lastComma >= 0) {
    const commaCount = (normalized.match(/,/g) ?? []).length
    const fractionAfterComma = normalized.slice(lastComma + 1)

    if (
      commaCount > 1 ||
      fractionAfterComma.length === 0 ||
      (fractionAfterComma.length === 3 && /^\d{3}$/.test(fractionAfterComma))
    ) {
      normalized =
        fractionAfterComma.length === 0
          ? normalized.slice(0, lastComma).replace(/,/g, '')
          : stripThousandSeparators(normalized)
    } else {
      normalized = parseDecimalComma(normalized, lastComma)
    }
  }

  const firstPeriod = normalized.indexOf('.')
  if (firstPeriod >= 0) {
    normalized =
      normalized.slice(0, firstPeriod + 1) + normalized.slice(firstPeriod + 1).replace(/\./g, '')
  }

  return isValidAmountInputRaw(normalized) ? normalized : ''
}

/** Formatea el valor crudo con separación de miles cada tres dígitos. */
export function formatAmountInputDisplay(raw: string): string {
  if (raw === '') return ''

  const dotIndex = raw.indexOf('.')
  const hasDecimal = dotIndex >= 0
  const integerPart = hasDecimal ? raw.slice(0, dotIndex) : raw
  const fractionalPart = hasDecimal ? raw.slice(dotIndex + 1) : ''

  const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, AMOUNT_THOUSAND_SEPARATOR)

  if (hasDecimal) {
    return `${groupedInteger}.${fractionalPart}`
  }

  return groupedInteger
}

/** Posición del cursor en la cadena formateada tras editar `rawPrefixLength` caracteres crudos. */
export function getDisplayCaretForRawLength(formatted: string, rawPrefixLength: number): number {
  if (rawPrefixLength <= 0) return 0

  let rawBuilt = ''
  for (let index = 0; index <= formatted.length; index += 1) {
    if (rawBuilt.length >= rawPrefixLength) {
      return index
    }
    if (index === formatted.length) break

    const char = formatted[index]!
    if (char >= '0' && char <= '9') {
      rawBuilt += char
    } else if (char === '.' && !rawBuilt.includes('.')) {
      rawBuilt += '.'
    }
  }

  return formatted.length
}
